// Só protótipo (fase de lógica, auth ainda não real): injeta um token no
// localStorage pra testar chamadas ao BFF sem o fluxo de login real.
// Uso no console do browser: window.setDevToken('<jwt>', '<tenant-slug>')
export function setDevToken(accessToken: string, tenantSlug: string) {
  localStorage.setItem('access_Token', accessToken);
  localStorage.setItem(
    'access_token_expiration_date',
    String(Math.floor(Date.now() / 1000) + 3600),
  );
  localStorage.setItem('auth_mode', 'sso');
  localStorage.setItem('tenant_slug', tenantSlug);
}

(window as unknown as Record<string, unknown>).setDevToken = setDevToken;
